'use strict';

var euContries = ['AT', 'BE', 'HR', 'BG', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE','IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE', 'GB'];

$(document).ready(function(){
    cookiesContent();
    blogFormActions();
    (function sessionCreation(){
        var url = window.location.href;
        var params = url.split('/');
        var length = params.length;             
        if(length > 0){
            sessionStorage.setItem('referenceId', params[length-1]);
        }    
    })();
    
    var referalName = sessionStorage.getItem('referenceId'); 
    if(referalName != null && referalName != "") {
        referalName = referalName.slice(0, -5);
        referalName = '?page=' + referalName +".html";        
    } else {
        referalName = '?page=';
    }    
    
    $("input#email").val('');
    $("input#name").val('');
    $("input#contact_no").val('');
    $("textarea#message").val('');  
    var site_base_url = window.location.origin;
     
    //window.rd = '3cfb7812-af79-4ac9-9708-3adf7eafab28'
    window.rd = '751269fb-e6ee-469f-a06a-e83d95356190'
    
    function encryptToken(value, secretKey) {
      return CryptoJS.AES.encrypt(value, secretKey).toString()
    }
    
    function getBrowserInfo() {
      return {
        osName: "Google's Android OS",
        osVersion: '6.0',
        browserName: 'Google Chrome',
        browserVersion: '108.0.5359.94'
      }
    }
    
    function getFormToken (formName, formData) {
        fetch(
          //'https://micontactforms-devapi.mi2.in/api/v1/create-contact-us-form-token',
          'https://micontactformsapi.mobisoftinfotech.com/api/v1/create-contact-us-form-token',
          {
            method: 'POST',
            body: JSON.stringify(getBrowserInfo()),
            headers: {
              'Content-type': 'application/json; charset=UTF-8'
            }
          }
        )
        .then(function (response) {
            return response.json()
          })
          .then(function (data) {
            console.log(data)
            var encryptedToken = encryptToken(data.token, window.rd)
            return submitContactUsFormData(formName, formData, encryptedToken)
        })
        .catch(function(error) {
          console.log('Error:', error);
        })
      }
    
      function submitContactUsFormData (formName, formData, encryptedToken) {
        var contactUsObj = {
            ...getBrowserInfo(),
            formData: formData,
            formName: formName,
            encryptedToken: JSON.stringify(encryptedToken)
          }
        fetch(
            //'https://micontactforms-devapi.mi2.in/api/v1/contact-us-form-messages',
            'https://micontactformsapi.mobisoftinfotech.com/api/v1/contact-us-form-messages',
            {
              method: 'POST',
              body: JSON.stringify(contactUsObj),
              headers: {
                'Content-type': 'application/json; charset=UTF-8'
              }
            }
          )
          .then(function (response) {
            return response.json()
          })
          .then(function (data) {
        
           window.location.href = site_base_url + "/thank-you.html";
            console.log('contact us submission data submitted successfully', data)
          })
          .catch(function(error) {
            console.log('Error:', error);
          })
    }

    jQuery(function() {
        $('.mserror, .mserror1, .mserror2').hide();
        
        $(".send-btn").click(function(e) {
            e.preventDefault();
    
             $('.mserror, .mserror1, .mserror2').hide();
            // validate and process form here           
            var name = $.trim($("input#name").val());
            if (name === "") {
                $("input#name").nextAll('.mserror').show();
                $("input#name").focus();
                return false;
            }
            var email = $.trim($("input#email").val());
            if (email === "") {
                $("input#email").nextAll('.mserror').show();
                $("input#email").focus();
                return false;
            }
            var emailval = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
            if (emailval.test(email) == false) {
                $("input#email").nextAll('.mserror1').show();
                return (false);
            }
            var country = $("#contact_no").intlTelInput("getSelectedCountryData").name;
            if (country === "" || country == null || typeof country == undefined) {
                $(".flag-container").parent().nextAll('.mserror2').show();
                $(".flag-container").focus();
                return false;
            } 
            var contact_no = $.trim($("input#contact_no").val()); 
            if (contact_no === "" || contact_no == null) {
                $("input#contact_no").parent().nextAll('.mserror').show();
                $("input#contact_no").focus();
                return false;
            }
            if(isNaN(contact_no)){
                 $("input#contact_no").parent().nextAll('.mserror1').show();
                $("input#contact_no").focus();
                return false;
            }

            contact_no = $("#contact_no").intlTelInput("getSelectedCountryData").dialCode + '-' + contact_no;
           
            var fleet = $.trim($("select#fleet").val());
            // if (fleet === "") {
            //     $("select#fleet").nextAll('.mserror').show();
            //     var select = $("select#fleet");
                
            //     return false;
            // }
            // var tokens_id = $(".tokens_id").val();
            // var uuid = window.contactToken;

            var message = $.trim($("textarea#message").val());
            $(".send-btn").html("Please wait...");
        $(".send-btn").attr("disabled", true);
            var formData = [
                {
                  fieldKey: 'name',
                  fieldValue: name
                },
                {
                  fieldKey: 'email',
                  fieldValue: email
                },
                {
                    fieldKey: 'fleetSize',
                    fieldValue: fleet
                },
                {
                  fieldKey: 'phone',
                  fieldValue: contact_no
                },
                {
                  fieldKey: 'message',
                  fieldValue: message
                }
              ]
            
              var formName = 'Truck Pulse'
              getFormToken(formName, formData)
            // var formVal = 'aB#7wwclanC25ZJ9D8nHkBx@';
    
            // if(euContry === true){
            //     if(!$('#cookies-chk1').is(':checked')){
            //         $('#cookies-chk1').focus();
            //         $('#cookies-chk1').parents('.form-group').find('.mserror1').show();                    
            //         return false;
            //     }
            // } 

            // var dataString = 'email=' + email + '&contact_no=' + contact_no + '&name=' + name + '&message=' + message + '&page-url='+window.location.href + '&country='+country + '&form_field='+formVal +'&fleet='+ fleet +'&tokens_id='+ tokens_id +'&uuid='+ uuid;
            // $.ajax({            
            //     type: "POST",
            //     url: "/postcontact.php",
            //     data: dataString,
            //     success: function(response) {                
            //         $("input#email").val('');
            //         $("input#name").val('');
            //         $("input#contact_no").val('');
            //         $("textarea#message").val('');     
            //         window.location.href = "/thank-you.html" + referalName;
            //         console.log(response);
            //         sessionStorage.clear(); 
            //     },           
            //     error: function(err){   
            //         console.log(err);
            //     }             
            // });
            return false;
        });
    }); 

var euContry, uCountry;

function cookiesContent(){      
    $.get('/country.php?' + Date.now(), function(resp) {
        if(resp != ""){
            uCountry = resp;
            getCont(uCountry);           
        }
    })
} 

$("#contact_no").intlTelInput({
    initialCountry: "auto",
    geoIpLookup: function(callback) {
        $.get('/country.php?time=' + Date.now(), function(resp) {
            if(resp != ""){                
                callback(resp);
            }
        })
    }
});



function getCont(uCountry){    
    if(jQuery.inArray(uCountry, euContries) !== -1){
        euContry = true;
        

        $('.other-cookies').hide();
        
        [{
                src: 'https://cdnjs.cloudflare.com/ajax/libs/cookieconsent2/3.0.3/cookieconsent.min.js'
            }].forEach(function(script) {
            var x = document.createElement("script");
            x.type = 'text/javascript';
            x.async = false;
            if (script.callback)
                x.onload = script.callback;
            document.head.appendChild(x);
            x.src = script.src;
        });
        [    'https://cdnjs.cloudflare.com/ajax/libs/cookieconsent2/3.0.3/cookieconsent.min.css'                
        ].forEach(function(src) {
            var l = document.createElement('link');
            l.rel = 'stylesheet';
            l.href = src;
            var h = document.getElementsByTagName('head')[0];
            h.appendChild(l);
        });       

        window.addEventListener("load", function(){
            window.cookieconsent.initialise({
                "palette": {
                    "popup": {
                      "background": "#616060",
                      "text": "#ffffff"
                    },
                    "button": {
                      "background": "#4b81e8",
                      "text": "#ffffff"
                    }                                
                },                
                "content": {
                "message": "By using this site you agree to the use of cookies for analytics and personalized content.",
                "href": "https://mobisoftinfotech.com/privacy-policy"
                }
            })
        });

    } else {
        $('.eu-cookies').hide();
}
};

function blogFormActions() {
    $("#blog-form-btn").on("click", function(e) {   
        e.preventDefault();
        $(".mserror,.mserror1").hide();    
        var name = $("#name-blog").val();
        var contact_number = $("#contact-blog").val();
        var email = $("#email-blog").val();
        var message = $("#msg-blog").val();
        var country = $("#country-blog").val();        
        var rx = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        var rxPhone = "^[- 0-9*#+]*$";        
        var formVal = 'aB#7wwclanC25ZJ9D8nHkBx@';     

        
        if (name == "") {            
            $("#name-blog").nextAll('.mserror').show();
            $("#name-blog").focus();
            return;
        }
        if (email == "") {
            $("#email-blog").nextAll(".mserror").show();
            $("#email-blog").focus();
            return;
        }
        if (!rx.test(email)) {
         $("#email-blog").nextAll(".mserror1").show();
         $("#email-blog").focus();
            return;
         }
        if (contact_number == "") {
            $("#contact-blog").nextAll(".mserror").show();
            $("#contact-blog").focus();
            return;
        }
        if(!contact_number.substring(0).match(rxPhone)){
            $("#contact-blog").nextAll(".mserror1").show();
            $("#contact-blog").focus();
            return;
        } 
        if (country == "" || typeof country == undefined || country == null) {
            $("#country-blog").nextAll(".mserror").show();
            $("#country-blog").focus();
            return false;;
        }
        var message = $.trim($("textarea#message").val());
        $("#blog-form-btn").html("Please wait...");
        $("#blog-form-btn").attr("disabled", true);
        var formData = [
            {
              fieldKey: 'name',
              fieldValue: name
            },
            {
              fieldKey: 'email',
              fieldValue: email
            },
            {
              fieldKey: 'phone',
              fieldValue: contact_number
            },
            {
                fieldKey: 'country',
                fieldValue: country
            },
            {
              fieldKey: 'message',
              fieldValue: message
            }
          ]
        
          var formName = 'Truck Pulse Insight'
          getFormToken(formName, formData)
        //  if(euContry === true){
        //     if(!$('#blog-cookies-chk1').is(':checked')){
        //         $('#blog-cookies-chk1').focus();
        //         $('.res-cookies-error').show();                    
        //         return false;
        //     }
        //  }    
        //  var tokens_id = $(".tokens_id").val();
        //     var uuid = window.contactToken;
        //  var dataString = 'email=' + email + '&contact_no=' + contact_number + '&name=' + name + '&message=' + message + '&page-url='+window.location.href + '&country='+country + '&form_field='+formVal +'&tokens_id='+ tokens_id +'&uuid='+ uuid;
        //     $.ajax({            
        //         type: "POST",
        //         url: "/postcontact.php",
        //         data: dataString,
        //         success: function(response) {                
        //             $("input#email-blog").val('');
        //             $("input#name-blog").val('');
        //             $("input#contact-blog").val('');
        //             $("textarea#msg-blog").val('');     
        //             window.location.href = "/thank-you.html" + referalName;
        //             console.log(response);
        //             sessionStorage.clear(); 
        //         },           
        //         error: function(err){   
        //             console.log(err);
        //         }             
        //     });
            return false;
        
        
               
    });
}
});
